//bao migrate skip
import * as ko from "knockout";
import Bao from "../../../services/bao-service";
import TabPage from "../../../factories/tab-page";
import BaoDialog from "../../../factories/bao-dialog";
import GenericListTab from "../../../factories/generic-list-tab";
import RoleShiftbookTabDialog from "./role-shiftbook-tab-dialog";

class RoleShiftbookTab extends GenericListTab {
    Bao = Bao;
    DialogWidth = 800;
    /** used in dialog to control detail view is on/off */
    DetailedView = ko.observable(false);
    /** used in dialog to control detail view is on/off */
    toggleDetailedView = () => { this.DetailedView(!this.DetailedView()); };
    /** used in manual foreach selection table */
    SelectedRow = ko.observable({});
    ShiftbookName = ko.observable<string>();
    RoleName = ko.observable<string>();
    roleShiftbookDialog: RoleShiftbookTabDialog = null;

    constructor(tabPage: TabPage, parent) {
        super(tabPage, parent);
        this.RoleName(ko.unwrap(parent.RoleName));
        this.Models.subscribe(() => {
            this.Selection([]);
        });
        // hack which is need to get the toolbarbuttons work with the manual selection binding implementation
        this.SelectedRow.subscribe((value) => {
            this.Selection([value]);
        });
    }
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(item): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        var result = true;
        def.resolve(result);
        return def.promise();
    }
    /**
     * ko data-bind click event on shiftbookname
     * @param data
     * @param event
     */
    OnClickShiftbookName(data, event) {
        this.OpenEditDialog(ko.unwrap(data.PrimaryKeyValue));
    }
    /**
     * ko data-bind click event on dialog's detail button
     * @param data
     * @param event
     */
    OnClickDetailButton(data, event) {
        this.toggleDetailedView();
    }
    /**
     * opens the dialog, checks the edit permission before
     * @param primaryKeyValue
     */
    private OpenEditDialog(primaryKeyValue: string) {
        // check if btn "edit" is available (permitted) and cancel if not
        if (!this.ToolbarButtons().filter(x => ko.unwrap(x.ActionKey) === this.PermissionEdit).map(x => ko.unwrap(x.Visible))[0]) {
            return;
        }
        this.Dialog(ko.unwrap(primaryKeyValue));
    }
    /**
     * overrides GenericListTab's Dailog Method
     * @param itemId
     */
    Dialog(itemId: string): JQueryPromise<void> {
        this.DetailedView(false);
        this.TabPage.IsLoading(true);
        return Bao.post(this.UrlDialog(), JSON.stringify({
            sessionTabId: this.SessionTabId,
            parentId: ko.unwrap(this.Parent.PrimaryKeyValue),
            id: itemId
        }), (result: Factories.GenericListResponse.DialogResponse) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            var okButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgOk"), () => {
                var item: RoleShiftbookTabDialog = dialog.ViewModel();
                this.ItemCompleteCheck.call(this, item).then((validateResult) => {
                    if (validateResult) {
                        const modelToSave = this.roleShiftbookDialog.GetModelToSave();
                        this.Save(modelToSave).then(() => {
                            this.TabPage.DirtyFlag(true);
                            dialog.Close();
                        });
                    }
                });
            });
            var cancelButton = new BaoDialog.ButtonFactory(dialog, Bao.Session.GetMessage("msgCancel"), () => {
                dialog.Close();
            });
            if (this.DialogWidth != null) {
                dialog.Width(this.DialogWidth + "px");
            }
            dialog.Buttons([okButton, cancelButton]);
            var vm = ko.map.fromJS(result.Model);
            vm.Parent = this;
            vm.fromShiftbook = false;
            vm.TabModel = (<any>result).TabModels;
            this.roleShiftbookDialog = new RoleShiftbookTabDialog(vm, dialog);
            dialog.ViewModel(this.roleShiftbookDialog);
            dialog.Template(result.Template);
            dialog.Open();
        }).always(_ => this.TabPage.IsLoading(false));
    }
    /**
     * overrides GenericListTab.Save to check the server response
     * @param item
     */
    public Save(item) {
        this.TabPage.IsLoading(true);
        return Bao.post('UadmFinitoCustom/RoleShiftbookTab/SaveAllTabs', JSON.stringify({
            sessionTabId: this.SessionTabId,
            mainDialogModel: item.mainDialogModel,
            generalTabModel: item.generalTabModel,
            roleShiftbookTabModel: item.roleShiftbookTabModel
        })).then((serverResult) => {
            if (serverResult) {
                if (serverResult.Result === false) {
                    new BaoDialog(null, serverResult.Message, "info");
                    // hack because the caller requires that this function uses an async this.Get() to unset IsLoading
                    window.setTimeout(() => {
                        this.TabPage.IsLoading(false);
                    }, 100);
                    return;
                }
            }
            return this.Get();
        }).always(_ => this.TabPage.IsLoading(false));
    };
}
export default RoleShiftbookTab;